import { DollarSign, ListChecks, GitPullRequest, Clock } from 'lucide-react';
import { RATES_PER_SECOND } from '../data/productivity-rates';
import { WasteCounterCard } from './waste-counter-card';

interface WasteCountersGridProps {
  elapsedSeconds: number;
}

export function WasteCountersGrid({ elapsedSeconds }: WasteCountersGridProps) {
  const cost = RATES_PER_SECOND.cost * elapsedSeconds;
  const tasks = RATES_PER_SECOND.tasks * elapsedSeconds;
  const prs = RATES_PER_SECOND.prs * elapsedSeconds;
  const minutesSaved = RATES_PER_SECOND.minutesSaved * elapsedSeconds;

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      <WasteCounterCard
        icon={DollarSign}
        label="Costo de oportunidad"
        sublabel="$75/hr × 40% ganancia IA"
        value={cost}
        decimals={2}
        prefix="$"
        color="red"
      />
      <WasteCounterCard
        icon={ListChecks}
        label="Tareas no completadas"
        sublabel="+26-55% tareas con IA"
        value={tasks}
        decimals={2}
        color="orange"
      />
      <WasteCounterCard
        icon={GitPullRequest}
        label="PRs no mergeados"
        sublabel="+60% PRs con IA (DX Insight)"
        value={prs}
        decimals={2}
        color="yellow"
      />
      <WasteCounterCard
        icon={Clock}
        label="Minutos desperdiciados"
        sublabel="24 min ahorrados por hora"
        value={minutesSaved}
        decimals={1}
        prefix=""
        color="red"
      />
    </div>
  );
}
